import { render, staticRenderFns } from "./SetPrimary.vue?vue&type=template&id=a947da76"
import script from "./SetPrimary.vue?vue&type=script&lang=js"
export * from "./SetPrimary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports